import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Answer } from "domain/entities/answer";
import { Logger } from "infra/logger/logger"
import answerRepository from "infra/repositories/answer-repository";

export const useCreateAnswersMutation = () => {
    const logger = Logger.getInstance();
    const answerQuery = useQueryClient();

    return useMutation({
        mutationFn: async (answers: Answer[]) => {
            const result = await answerRepository.create(answers);
            return result;
        },
        onSuccess: () => {
            answerQuery.invalidateQueries({queryKey: ["FormsAnswer", {}]});
        },
        onError: (error) => {
            if (error instanceof AxiosError) {
                console.log("raw error:", error)
                if (error.response?.data?.metadata?.errors) {
                    const errors = error.response.data.metadata.errors;
                    logger.error(errors[0], error.response?.data.metadata);
                    console.log("error axios",errors[0]);
                    //Cria um objeto de erro com o array de erros como propriedade
                    const customError = new Error("Erro ao criar answers do form");
                    (customError as any).errors = errors; // Adiciona o array de erros ao objeto de erro
                     throw customError;
                } else {
                    throw new Error("Erro desconhecido da API");
                }
            }else {
                logger.error("Erro desconhecido", error);
                throw error;
            }
        }
    });
}